import { useSuspenseQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { users } from 'src/shared/features/users/queries/user-queries'

export type UserZillowReview = {
  date?: string | null
  description?: string | null
  locationZipcode?: string | null
  rating?: number | null
  reviewerFullName?: string | null
  serviceDescription?: string | null
}

export type UserZillowReviewResponse = {
  averageRating?: number | null
  revieweeProfileUrl?: string | null
  totalReviews?: number | null
  reviews: UserZillowReview[]
} | null

const getUserReviews = async (userId: number): Promise<UserZillowReviewResponse> => {
  try {
    const response = await getRequest<UserZillowReviewResponse>(`/users/zillow-reviews?user_id=${userId}`)
    if (!response) {
      return null
    }
    return response
  } catch (error) {
    console.error('Error fetching user reviews:', error)
    return null
  }
}

export const useUserReviews = (userId: number) => {
  return useSuspenseQuery({
    queryKey: users.reviews(userId).queryKey,
    queryFn: () => (userId < 0 ? null : getUserReviews(userId)),
    retry: false,
    staleTime: 5 * 60 * 1000,
  })
}
